// Globals
import React, { SyntheticEvent } from 'react';
import { Switch } from 'antd';
import { useTranslation } from 'react-i18next';

// Components
import { PopConfirm } from '@/ui';
import DisablePaymentMethodErrorModal from '../DisablePaymentMethodErrorModal/DisablePaymentMethodErrorModal';

// Helpers
import { useBoolean } from '@/hooks';
import { useUpdatePaymentMethod } from '../../hooks/useUpdatePaymentMethod';

type TPaymentMethodSwitch = {
  paymentMethodId: string;
  enabled: boolean;
  canDisable: boolean;
};

const PaymentMethodSwitch = ({ paymentMethodId, enabled, canDisable }: TPaymentMethodSwitch) => {
  const { t } = useTranslation(['common']);
  const { value: isErrorModalOpen, setTrue: openErrorModal, setFalse: closeErrorModal } = useBoolean();
  const { updatePaymentMethod, isLoading } = useUpdatePaymentMethod();

  const handleChange = () => {
    if (!canDisable && enabled) {
      openErrorModal();
      return;
    }
    updatePaymentMethod(paymentMethodId, !enabled);
  };

  const handleStopPropagation = (e: SyntheticEvent) => {
    e.stopPropagation();
  };

  return (
    <>
      <div onClick={handleStopPropagation} onKeyDown={handleStopPropagation}>
        <PopConfirm
          title={t(enabled ? 'modal_payment_method_hide_title' : 'modal_payment_method_title')}
          onConfirm={handleChange}
        >
          <Switch
            checked={enabled}
            checkedChildren={t('modal_payment_method_enabled_title')}
            unCheckedChildren={t('modal_payment_method_disabled_title')}
            loading={isLoading}
          />
        </PopConfirm>
      </div>
      <DisablePaymentMethodErrorModal isOpen={isErrorModalOpen} onClose={closeErrorModal} />
    </>
  );
};

export default PaymentMethodSwitch;
